/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimeEntryRouteImport } from './routes/time-entry'
import { Route as OverviewRouteImport } from './routes/overview'
import { Route as CustomerReportRouteImport } from './routes/customer-report'
import { Route as ContactSupportRouteImport } from './routes/contact-support'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin-settings.index'
import { Route as OverviewLeistungsnachweisRouteImport } from './routes/overview.leistungsnachweis'
import { Route as AdminSettingsZmSyncRouteImport } from './routes/admin-settings.zm-sync'
import { Route as AdminSettingsProjectHoursRouteImport } from './routes/admin-settings.project-hours'
import { Route as AdminSettingsLoggedHoursRouteImport } from './routes/admin-settings.logged-hours'
import { Route as AdminSettingsLeistungsnachweisRouteImport } from './routes/admin-settings.leistungsnachweis'

const TimeEntryRoute = TimeEntryRouteImport.update({
  id: '/time-entry',
  path: '/time-entry',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewRoute = OverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerReportRoute = CustomerReportRouteImport.update({
  id: '/customer-report',
  path: '/customer-report',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactSupportRoute = ContactSupportRouteImport.update({
  id: '/contact-support',
  path: '/contact-support',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/admin-settings/',
  path: '/admin-settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewLeistungsnachweisRoute =
  OverviewLeistungsnachweisRouteImport.update({
    id: '/leistungsnachweis',
    path: '/leistungsnachweis',
    getParentRoute: () => OverviewRoute,
  } as any)
const AdminSettingsZmSyncRoute = AdminSettingsZmSyncRouteImport.update({
  id: '/admin-settings/zm-sync',
  path: '/admin-settings/zm-sync',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsProjectHoursRoute =
  AdminSettingsProjectHoursRouteImport.update({
    id: '/admin-settings/project-hours',
    path: '/admin-settings/project-hours',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsLoggedHoursRoute =
  AdminSettingsLoggedHoursRouteImport.update({
    id: '/admin-settings/logged-hours',
    path: '/admin-settings/logged-hours',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsLeistungsnachweisRoute =
  AdminSettingsLeistungsnachweisRouteImport.update({
    id: '/admin-settings/leistungsnachweis',
    path: '/admin-settings/leistungsnachweis',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact-support': typeof ContactSupportRoute
  '/customer-report': typeof CustomerReportRoute
  '/overview': typeof OverviewRouteWithChildren
  '/time-entry': typeof TimeEntryRoute
  '/admin-settings/leistungsnachweis': typeof AdminSettingsLeistungsnachweisRoute
  '/admin-settings/logged-hours': typeof AdminSettingsLoggedHoursRoute
  '/admin-settings/project-hours': typeof AdminSettingsProjectHoursRoute
  '/admin-settings/zm-sync': typeof AdminSettingsZmSyncRoute
  '/overview/leistungsnachweis': typeof OverviewLeistungsnachweisRoute
  '/admin-settings': typeof AdminSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact-support': typeof ContactSupportRoute
  '/customer-report': typeof CustomerReportRoute
  '/overview': typeof OverviewRouteWithChildren
  '/time-entry': typeof TimeEntryRoute
  '/admin-settings/leistungsnachweis': typeof AdminSettingsLeistungsnachweisRoute
  '/admin-settings/logged-hours': typeof AdminSettingsLoggedHoursRoute
  '/admin-settings/project-hours': typeof AdminSettingsProjectHoursRoute
  '/admin-settings/zm-sync': typeof AdminSettingsZmSyncRoute
  '/overview/leistungsnachweis': typeof OverviewLeistungsnachweisRoute
  '/admin-settings': typeof AdminSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contact-support': typeof ContactSupportRoute
  '/customer-report': typeof CustomerReportRoute
  '/overview': typeof OverviewRouteWithChildren
  '/time-entry': typeof TimeEntryRoute
  '/admin-settings/leistungsnachweis': typeof AdminSettingsLeistungsnachweisRoute
  '/admin-settings/logged-hours': typeof AdminSettingsLoggedHoursRoute
  '/admin-settings/project-hours': typeof AdminSettingsProjectHoursRoute
  '/admin-settings/zm-sync': typeof AdminSettingsZmSyncRoute
  '/overview/leistungsnachweis': typeof OverviewLeistungsnachweisRoute
  '/admin-settings/': typeof AdminSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact-support'
    | '/customer-report'
    | '/overview'
    | '/time-entry'
    | '/admin-settings/leistungsnachweis'
    | '/admin-settings/logged-hours'
    | '/admin-settings/project-hours'
    | '/admin-settings/zm-sync'
    | '/overview/leistungsnachweis'
    | '/admin-settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact-support'
    | '/customer-report'
    | '/overview'
    | '/time-entry'
    | '/admin-settings/leistungsnachweis'
    | '/admin-settings/logged-hours'
    | '/admin-settings/project-hours'
    | '/admin-settings/zm-sync'
    | '/overview/leistungsnachweis'
    | '/admin-settings'
  id:
    | '__root__'
    | '/'
    | '/contact-support'
    | '/customer-report'
    | '/overview'
    | '/time-entry'
    | '/admin-settings/leistungsnachweis'
    | '/admin-settings/logged-hours'
    | '/admin-settings/project-hours'
    | '/admin-settings/zm-sync'
    | '/overview/leistungsnachweis'
    | '/admin-settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactSupportRoute: typeof ContactSupportRoute
  CustomerReportRoute: typeof CustomerReportRoute
  OverviewRoute: typeof OverviewRouteWithChildren
  TimeEntryRoute: typeof TimeEntryRoute
  AdminSettingsLeistungsnachweisRoute: typeof AdminSettingsLeistungsnachweisRoute
  AdminSettingsLoggedHoursRoute: typeof AdminSettingsLoggedHoursRoute
  AdminSettingsProjectHoursRoute: typeof AdminSettingsProjectHoursRoute
  AdminSettingsZmSyncRoute: typeof AdminSettingsZmSyncRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/time-entry': {
      id: '/time-entry'
      path: '/time-entry'
      fullPath: '/time-entry'
      preLoaderRoute: typeof TimeEntryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview': {
      id: '/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof OverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-report': {
      id: '/customer-report'
      path: '/customer-report'
      fullPath: '/customer-report'
      preLoaderRoute: typeof CustomerReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-support': {
      id: '/contact-support'
      path: '/contact-support'
      fullPath: '/contact-support'
      preLoaderRoute: typeof ContactSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-settings/': {
      id: '/admin-settings/'
      path: '/admin-settings'
      fullPath: '/admin-settings'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview/leistungsnachweis': {
      id: '/overview/leistungsnachweis'
      path: '/leistungsnachweis'
      fullPath: '/overview/leistungsnachweis'
      preLoaderRoute: typeof OverviewLeistungsnachweisRouteImport
      parentRoute: typeof OverviewRoute
    }
    '/admin-settings/zm-sync': {
      id: '/admin-settings/zm-sync'
      path: '/admin-settings/zm-sync'
      fullPath: '/admin-settings/zm-sync'
      preLoaderRoute: typeof AdminSettingsZmSyncRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-settings/project-hours': {
      id: '/admin-settings/project-hours'
      path: '/admin-settings/project-hours'
      fullPath: '/admin-settings/project-hours'
      preLoaderRoute: typeof AdminSettingsProjectHoursRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-settings/logged-hours': {
      id: '/admin-settings/logged-hours'
      path: '/admin-settings/logged-hours'
      fullPath: '/admin-settings/logged-hours'
      preLoaderRoute: typeof AdminSettingsLoggedHoursRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-settings/leistungsnachweis': {
      id: '/admin-settings/leistungsnachweis'
      path: '/admin-settings/leistungsnachweis'
      fullPath: '/admin-settings/leistungsnachweis'
      preLoaderRoute: typeof AdminSettingsLeistungsnachweisRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface OverviewRouteChildren {
  OverviewLeistungsnachweisRoute: typeof OverviewLeistungsnachweisRoute
}

const OverviewRouteChildren: OverviewRouteChildren = {
  OverviewLeistungsnachweisRoute: OverviewLeistungsnachweisRoute,
}

const OverviewRouteWithChildren = OverviewRoute._addFileChildren(
  OverviewRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactSupportRoute: ContactSupportRoute,
  CustomerReportRoute: CustomerReportRoute,
  OverviewRoute: OverviewRouteWithChildren,
  TimeEntryRoute: TimeEntryRoute,
  AdminSettingsLeistungsnachweisRoute: AdminSettingsLeistungsnachweisRoute,
  AdminSettingsLoggedHoursRoute: AdminSettingsLoggedHoursRoute,
  AdminSettingsProjectHoursRoute: AdminSettingsProjectHoursRoute,
  AdminSettingsZmSyncRoute: AdminSettingsZmSyncRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
